import { RegistrationMember } from './RegistrationMember';

export default RegistrationMember;
